import React, { useEffect, useState } from "react";
import BannerSections from "src/Components/WebsiteComponents/HomePage/BannerSections";
import HealthPackageCard from "src/Components/WebsiteComponents/HomePage/Cards/HealthPackageCard";
import HomcareProduct from "src/Components/WebsiteComponents/HomePage/Cards/HomcareProduct";
import PharmaCard from "src/Components/WebsiteComponents/HomePage/Cards/PharmaCard";
import HealthProfileSection from "src/Components/WebsiteComponents/HomePage/HealthProfileSection";
import MainBannerSections from "src/Components/WebsiteComponents/HomePage/MainBannerSections";
import ProductViewSection from "src/Components/WebsiteComponents/HomePage/ProductViewSection";
import TextLineSection from "src/Components/WebsiteComponents/HomePage/TextLineSection";
import TopCategory from "src/Components/WebsiteComponents/HomePage/TopCategory";
import BG_Image from "src/assets/images/website-images/bg-image.png";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { ImageBaseUrl, QueryPath } from "src/lib/constans";
import { convertToKebabCase, parseQueryParams } from "src/helpers/helperFunctions";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NoItemUI from "src/Components/NoItemUI";
import ErrorIcon from "src/assets/images/not-data/incident.png";
import { removeAllDisLike } from "src/Store/disLike";

const extractBanners = (data) => {
  return data.flatMap((item) => {
    return Object.values(item)
      .filter((value) => value && typeof value === "object" && value.image) // Sirf banner objects
      .map((banner) => ({
        image: banner.image,
        promotionalTagId: banner.promotionalTagId,
        promotionalTagName: banner.promotionalTagName,
        _id: banner._id,
      }));
  });
};

const HomePageWebsite = () => {
  const [data, setData] = useState();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { isLogged } = useSelector((state) => state.appReducer);

  // DISLIKE MANAGEMENT REAL_TIME
  const { pharmacyDisLike } = useSelector((state) => state.disLike);
  const dispatch = useDispatch();



  const fetchMainPageData = async () => {
    console.log("isLogged", isLogged);
    setLoading(true);
    const { res, err } = await httpRequest({
      path: "/website-manage/login-home",
    });
    if (res) {
      setData(res);
    } else {
      toast(err, { type: "error" });
      setError(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchMainPageData();
  }, [isLogged]);


  useEffect(() => {
    if (data) {
      if (pharmacyDisLike.length > 0) {
        console.log("pharmacyDisLike", pharmacyDisLike);
        let updatedData = data?.sectionFour[0]?.productDetails?.map((v) => ({
          ...v,
          isLiked: pharmacyDisLike.find((i) => i === v?._id)
            ? false
            : v?.isLiked,
        }));
        setData((prev) => ({ ...prev, sectionFour: [{ ...prev?.sectionFour[0], productDetails: updatedData }] }));
        dispatch(removeAllDisLike("pharmacyDisLike"));
      }
    }
  }, [pharmacyDisLike]);

  if (error) {
    return <div className="w-full py-16 bg-banner-white-image flex items-center justify-center">
      <NoItemUI
        text="An error occurred while fetching the data"
        text2="Please try again later"
        iconImagePath={ErrorIcon}
        onButtonClick={() => {
          setError(null);
          fetchMainPageData();
        }}
        ButtonText="Try Again"
      />
    </div>;
  }

  return (
    <div className="relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-fit z-[-1]">
        {Array.from({ length: 10 }).map((item, index) => (
          <img
            src={BG_Image}
            alt="BG_Image"
            className={`w-full h-full object-cover ${index % 2 !== 0 && "scale-x-[-1]"
              }`}
            key={index}
          />
        ))}
      </div>
      <MainBannerSections
        isLoading={loading}
        images={data?.sectionOne ? extractBanners(data?.sectionOne) : []}
      />
      <TopCategory
        data={
          data?.sectionTwo
            ? data?.sectionTwo?.map((item) => ({
              title: item?.mainCategoryName,
              image: item?.topCategoryImage,
              mainCategoryId: item?.mainCategoryId,
              mainCategoryName: item?.mainCategoryName,
            }))
            : []
        }
        isLoading={loading}
      />
      <BannerSections
        images={
          data?.sectionThree
            ? data?.sectionThree?.map((item) => ({
              image: item?.banner,
              name: item?.mainCategoryName,
              mainCategoryId: item?.mainCategoryId,
              mainCategoryName: item?.mainCategoryName,
            }))
            : []
        }
        bannerClassName="h-auto cursor-pointer max-h-[50vh]"
        loadingClassName="max-h-[50vh]"
        isLoading={loading}
        id="pharma-banner-first"
        onClick={(data) => {
          navigate(`/category/${convertToKebabCase(data?.mainCategoryName)}?${parseQueryParams({
            [QueryPath.mainCategory]: data?.mainCategoryId || "",
            [QueryPath.mainCategoryName]: data?.mainCategoryName || "",
          })}`);
        }}
      />
      <TextLineSection />
      <ProductViewSection
        id={"pharma-product-"}
        title={data?.sectionFour[0]?.heading || "Title Not Found"}
        data={
          data?.sectionFour[0]?.productDetails.map((item) => ({
            ...item,
            mainImage: item?.image,
          })) || []
        }
        renderProduct={(data, index, id) => (
          <PharmaCard id={id + index} product={data} />
        )}
        isLoading={loading}
        renderSkeleton={<PharmaCard skeleton />}
      />
      <BannerSections
        images={
          data?.sectionFive
            ? data?.sectionFive?.map((item) => ({
              image: item?.homeCareBanner,
              name: item?.categoryName,
              _id: item?.homeCareCategoryId,
            }))
            : []
        }
        bannerClassName="h-auto cursor-pointer max-h-[60vh]"
        loadingClassName="h-[500px] max-h-[60vh]"
        isLoading={loading}
        id="pharma-banner" i
        onClick={(data) => {
          navigate(`/home-care?${QueryPath.homeCareCategory}=${data?._id}&${QueryPath.homeCareCategoryName}=${encodeURIComponent(data?.name)}`);
        }}
      />
      <ProductViewSection
        id={"homacare-product-"}
        title={data?.sectionSix?.[0]?.heading || "Title Not Found"}
        data={data?.sectionSix?.[0]?.homecareservicesDetails || []}
        isLoading={loading}
        renderProduct={(data, index, id) => (
          <HomcareProduct data={data} gaps={true} id={id + index} />
        )}
        renderSkeleton={<HomcareProduct skeleton />}
      />
      <BannerSections
        images={
          data?.sectionSeven
            ? [
              ...(data?.sectionSeven[0]?.doctorBannerOne
                ? [
                  {
                    image:
                      data?.sectionSeven[0]?.doctorBannerOne,
                  },
                ]
                : []),
              ...(data?.sectionSeven[0]?.doctorBannerTwo
                ? [
                  {
                    image:
                      data?.sectionSeven[0]?.doctorBannerTwo,
                  },
                ]
                : []),
            ]
            : []
        }
        bannerClassName="h-auto cursor-pointer"
        loadingClassName="h-[320px] max-h-[40vh]"
        isLoading={loading}
        id="duo-banner"
        onClick={(data) => {
          navigate(`/consult-a-doctor`);
        }}
      />
      <ProductViewSection
        id={"test-product-"}
        title={data?.sectionEight?.[0]?.heading || "Title Not Found"}
        data={data?.sectionEight?.[0]?.packageDetails || []}
        renderProduct={(data, index, id) => (
          <HealthPackageCard id={id + index} data={data} />
        )}
        isLoading={loading}
        renderSkeleton={<HealthPackageCard skeleton />}
      />
      <HealthProfileSection />
      <div className="w-full h-fit mb-5">
        <BannerSections
          id="last-banner"
          isLoading={loading}
          images={
            data?.sectionNine
              ? [
                ...(data?.sectionNine[0]?.bannerOne
                  ? [
                    {
                      image: data?.sectionNine[0]?.bannerOne,
                    },
                  ]
                  : []),
                ...(data?.sectionNine[0]?.bannerTwo
                  ? [
                    {
                      image: data?.sectionNine[0]?.bannerTwo,
                    },
                  ]
                  : []),
                ...(data?.sectionNine[0]?.bannerThree
                  ? [
                    {
                      image:
                        data?.sectionNine[0]?.bannerThree,
                    },
                  ]
                  : []),
                ...(data?.sectionNine[0]?.bannerFour
                  ? [
                    {
                      image:
                        data?.sectionNine[0]?.bannerFour,
                    },
                  ]
                  : []),
              ]
              : []
          }
          bannerClassName="h-auto cursor-pointer"
          loadingClassName="h-[320px] max-h-[40vh]"
          onClick={(data) => {
            navigate(`/consult-a-doctor`);
          }}
        />
      </div>
    </div>
  );
};

export default HomePageWebsite;
